import styled from 'styled-components'
import {FormikGooglePlacesCombobox} from '~/src/design-system-shims'
import React from 'react'
import type {IAgencyBase} from '~/src/models'
import type {IBaseAddress} from '~/src/models/baseAddress'
import {Button as IconButton} from '~/src/design-system/Primitives'

const CloseButton = styled(IconButton).attrs({variant: 'ghost' as const})({
  display: 'none',
  height: 28,
})

/** DS-layout: use Stack/Grid from ~/src/design-system for new layout code */
const Container = styled('div')({
  position: 'relative',

  '& + &': {
    marginTop: 'var(--space-8)',
  },

  [`&:hover ${CloseButton}`]: {
    display: 'flex',
  },
})

const Field = styled('div')({
  position: 'relative',
})

interface IProps {
  activePlatform: string
  remove?: (index: number) => void
  setFieldValue: (field: string, value: unknown) => void
  address: IBaseAddress | string | number | boolean | null | undefined
  initialEditValues?: IAgencyBase
  name: string
}

export default function AddressAutoComplete(props: IProps) {
  const {setFieldValue, address} = props

  return (
    <Container data-testid="address-autocomplete">
      <Field>
        <FormikGooglePlacesCombobox
          data-testid="address-autocomplete-input"
          address={address}
          name={props.name}
          initialEditValues={props.initialEditValues}
          setFieldValue={setFieldValue}
        />
      </Field>
    </Container>
  )
}
